import React from 'react'
import Chip from '@mui/material/Chip';

const Chips = ({item, handelStateDelete}) => {
    return <Chip
        sx={{fontSize: "1.4rem"}}
        label={ (item.prefix  || "") + item.label}
        variant="outlined"
        onDelete={() => handelStateDelete(item)}
    />
}

export default function FilterChips({chipData, handelStateDelete}) {
  return (
    <div className="chips-container">
        {
            chipData.map((item) => <Chips key={item.type + item.label} item={item} handelStateDelete={handelStateDelete}/>)
        }
    </div>
  )
}
